import { render, staticRenderFns } from "./HeadCmp.vue?vue&type=template&id=72b14fed&scoped=true"
import script from "./HeadCmp.vue?vue&type=script&lang=js"
export * from "./HeadCmp.vue?vue&type=script&lang=js"
import style0 from "./HeadCmp.vue?vue&type=style&index=0&id=72b14fed&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b14fed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b14fed')) {
      api.createRecord('72b14fed', component.options)
    } else {
      api.reload('72b14fed', component.options)
    }
    module.hot.accept("./HeadCmp.vue?vue&type=template&id=72b14fed&scoped=true", function () {
      api.rerender('72b14fed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claimsManagement/claimList/cmp/HeadCmp.vue"
export default component.exports